import { appConfig } from '@common/config';
import { Category, type ICategoryProp } from '@components/Category';
import { Checkbox, type ICheckbox } from '@components/Checkbox';
import { type IPriceParams } from '@interface/IItemPrice';
import { useTranslation } from 'react-i18next';
import { FilterWrapTempl } from './FilterWrapTempl';

export const FilterWrapBnsNeo = ({ props }: { props: IPriceParams }) => {
    const { t } = useTranslation();

    const classCheckProp: ICheckbox = {
        title: t('common.class'),
        resetObj: { page: '' },
        watch: 'class',
        cls: 'class',
        path: `/${appConfig.service}/v2.0/game/character/class`,
        ga360str: '사전_조건검색_클래스_클릭',
        activeChecked: props.paramClass,
    };

    const gradeCheckProp: ICheckbox = {
        title: t('common.grade'),
        resetObj: { page: '' },
        watch: 'grade',
        cls: 'grades',
        path: `/${appConfig.service}/v2.0/game/item/grade`,
        ga360str: '사전_조건검색_등급_클릭',
        activeChecked: props.paramGrade,
    };

    const categoryProp: ICategoryProp = {
        title: t('common.category'),
        watchD1: 'category1',
        watchD2: 'category2',
        path: `/${appConfig.service}/v2.0/game/item/category`,
        ga360str: '사전_조건검색_카테고리_클릭',
        activeCategory1: props.paramCategory1,
        activeCategory2: props.paramCategory2,
    };

    return (
        <FilterWrapTempl refreshObj={refObj}>
            <Checkbox props={classCheckProp} />
            <Checkbox props={gradeCheckProp} />
            <Category props={categoryProp} />
        </FilterWrapTempl>
    );
};

const refObj = {
    class: '',
    grade: '',
    category1: '',
    category2: '',
    page: '',
};
